import { ConcreteProduct, DeserializedAbstractProduct } from '@/src/lib/product/types';
import { DeserializedObject } from '@/src/lib/http/jsonapi/deserializer';
import { isAbstractProduct, isConcreteProduct } from '@/src/lib/product/business/product-item';
import { DeserializedConcreteProduct } from '@/src/lib/catalog-search/types';

export function isProductBuyable(concreteProduct?: DeserializedObject<ConcreteProduct> | DeserializedConcreteProduct) {
  return !!concreteProduct?.isBuyable;
}

export function getMinimumOrderAmount(
  product: DeserializedObject<DeserializedAbstractProduct | ConcreteProduct> | DeserializedConcreteProduct,
): number {
  if (isConcreteProduct(product) || 'minOrderAmount' in product) {
    return product.minOrderAmount || 0;
  }

  if (isAbstractProduct(product) && product.concreteProducts?.[0].minOrderAmount) {
    return product.concreteProducts?.[0].minOrderAmount;
  }

  return 1;
}

export function getIsNeverOutOfStock(
  product: DeserializedObject<DeserializedAbstractProduct | ConcreteProduct> | DeserializedConcreteProduct,
) {
  if (isConcreteProduct(product) && product.concreteProductAvailabilities?.length) {
    return !!product.concreteProductAvailabilities?.[0].isNeverOutOfStock;
  }

  return product.concreteProducts?.[0].neverOutOfStock;
}
